<template>
  <div class="recharge">
    <!-- <PersonIndex :showRechargeBtn="false" :info="userInfoData"> -->
    <div class="title">
      <p>请选择领取方式</p>
      <span></span>
    </div>
    <div class="pageCarServeShadow cardTab" @click="handleSel">
      <p class="tabNav left" :class="{ active: active === 1 }">电子券领取</p>
      <p class="tabNav right" :class="{ active: active === 0 }">实体卡绑定</p>
    </div>
    <div class="tabItem">
      <div class="form">
        <van-field
          v-if="active === 1"
          class="pageInput phone"
          v-model="phone"
          :border="false"
          type="number"
          maxlength="11"
          readonly
          placeholder="请输入手机号码"
          @clear="handleClearMobile"
        />
        <van-field
          v-if="active === 0"
          class="pageInput phone"
          v-model="code"
          :border="false"
          type="number"
          maxlength="16"
          placeholder="请输入实体卡密码"
          @clear="handleClearMobile"
          id="carpwd"
        />
        <div class="agreement">
          <van-checkbox
            v-model="checked"
            shape="square"
            icon-size="14px"
            label-disabled
            >已阅读并同意
            <div class="agreement-content">
              <span class="text" @click="agreementClickHandle()"
                >《用户注册协议及用户信息使用须知》</span
              >
            </div>
          </van-checkbox>
        </div>
        <KBtn
          class="pageBigBtns"
          color="var(--depYelColor)"
          :title="active === 1 ? '领取' : '绑定'"
          size="big"
          @click="handleClick"
        />
      </div>
    </div>
    <div v-if="active === 0">
      <p style="float: right; margin-top: 20px; color: blue" @click="batchBind">
        批量绑定>>>
      </p>
    </div>
    <Tips :content="content" v-if="content != ''" />
    <!-- </PersonIndex> -->
    <RegisterAndInfo ref="registerAndInfo"></RegisterAndInfo>
  </div>
</template>
<script>
import { getUserInfo } from "api/user";
import { receive } from "api/submit";
import RegisterAndInfo from "../agreement/user/registerAndInfo.vue";
export default {
  components: {
    RegisterAndInfo,
  },
  data() {
    return {
      active: 1,
      userInfoData: {},
      content: "",
      phone: "",
      code: "",
      checked: true,
    };
  },
  mounted() {
    //引入腾讯验证
    // let that = this;
    // this.captcha1 = new TencentCaptcha("2010760250", function (res) {
    //   that.bindCard(res);
    // });
    this.getUserInfo();
  },
  methods: {
    handleClick() {
      if (this.active === 1 && !this.phone) {
        this.$error("请输入手机号码");
        return false;
      }
      if (this.active === 0 && !this.code) {
        this.$error("请输入卡券密码");
        document.getElementById("carpwd").focus();
        return false;
      }
      if (this.active === 0 && !(this.code.length === 16)) {
        this.$error("请输入正确的卡券密码");
        document.getElementById("carpwd").focus();
        return false;
      }
      if (!this.checked) {
        this.$error("请先阅读并勾选同意协议！");
        return false;
      }
      if (this.active === 1) {
        this.$loading("查询中...");
        receive(this.active, this.phone).then((res) => {
          this.$clear();
          if (res.status == 200) {
            this.$successSync(res.message, () => {
              this.$push({
                path: "/coupons",
              });
            });
          } else {
            this.$error(res.message);
          }
        });
      } else {
        this.$loading("绑定中...");
        receive(this.active, this.phone, this.code).then((res) => {
          this.$clear();
          if (res.status == 200) {
            this.$successSync(res.message, () => {
              this.$push({
                path: "/coupons",
              });
            });
          } else {
            this.$error(res.message);
          }
        });
      }
    },
    bindCard(res) {
      // res（用户主动关闭验证码）= {ret: 2, ticket: null}
      // res（验证成功） = {ret: 0, ticket: "String", randstr: "String"}
      if (res.ret === 0) {
        this.handleComfirm(res.randstr, res.ticket); // 票据
      }
    },
    handleComfirm() {
      this.captcha1.destroy();
    },
    handleClearMobile() {
      this.mobile = null;
    },
    getUserInfo() {
      getUserInfo().then((res) => {
        if (res.status == 200) {
          this.phone = res.data.userPhone;
        }
      });
    },
    handleSel(e) {
      if (e.target.className.includes("left")) {
        this.active = 1;
      } else {
        this.active = 0;
      }
    },
    batchBind() {
      this.$push({
        path: "/batchEntity",
      });
    },
    agreementClickHandle() {
      this.$refs["registerAndInfo"].show = true;
    },
  },
};
</script>

<style scoped lang="less">
@thColor: var(--depYelColor);
.recharge {
  margin: 0 20px;
  .title {
    margin-top: 20px;
    text-align: center;
    font-size: var(--titleFont);
    color: var(--hidColor);
    p {
      background: var(--bgColor);
      padding: 0 8px;
      display: inline-block;
      font-weight: var(--defaultFontWeight);
    }
    span {
      width: 100%;
      height: 1px;
      display: block;
      border-top: 1px dotted #ddd;
      margin-top: -10px;
    }
  }
  .cardTab {
    margin: 25px auto;
    width: 80%;
    padding: 0;
    .tabNav {
      display: inline-block;
      width: 50%;
      padding: 6px 0;
      text-align: center;
      color: var(--depHidColor);
      font-weight: var(--defaultFontWeight);
      font-size: var(--pFont);
      background: #fff;
    }
    .left {
      border-top-left-radius: 5px;
      border-bottom-left-radius: 5px;
    }
    .right {
      border-top-right-radius: 5px;
      border-bottom-right-radius: 5px;
    }
    .active {
      position: relative;
      color: #fff;
      background: @thColor;
      &::after {
        content: "";
        width: 0;
        height: 0;
        position: absolute;
        bottom: -10px;
        left: 45%;
        border-width: 5px;
        border-style: solid;
        border-color: @thColor transparent transparent transparent;
      }
    }
  }
}
.form {
  .pageInput {
    border-color: var(--depYelColor);
    position: relative;
  }
  ::placeholder {
    color: #999;
    font-size: 16px;
    font-weight: normal;
  }
  /deep/.van-cell {
    margin-top: 18px;
    height: 50px;
    line-height: 31px;
    /deep/.van-field__control {
      color: var(--depYelColor);
      font-size: 16px;
    }
    /deep/.van-field__button {
      margin-top: -5px;
    }
    /deep/.van-button--small {
      padding: 0px 5px;
      height: 27px;
      border-radius: var(--defaultRadius);
      box-sizing: border-box;
      margin-top: -3px;
      display: inline-block;
    }
    /deep/.van-icon {
      right: 0;
      position: absolute;
    }
  }
  /deep/ .van-dialog {
    .van-cell {
      margin: 10px 0px 20px 0px;
      .van-field__control {
        color: initial;
        line-height: 20px !important;
        height: 50px;
      }
      .van-field__control::-webkit-input-placeholder {
        color: #333;
        font-size: 14px;
      }
    }
    /deep/ .van-hairline--top {
      margin-top: 20px;
    }
  }
  .phone {
    /deep/.van-field__control {
      font-weight: 900;
      font-size: 20px;

      text-align: center;
      line-height: initial;
    }
  }
  .pageBigBtns {
    margin-top: 20px;
  }
  .agreement {
    margin-top: 15px;
    font-size: var(--smallFont);
    /deep/.van-checkbox__label {
      line-height: normal;
      color: #999;
    }
    .agreement-content {
      display: inline;
      .text {
        font-weight: 700;
      }
    }
  }
}
</style>
